export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyDJkfYZycQ1nRT9hvhWTnEQ3wWT5PjZCwo",
    authDomain: "arons-site.firebaseapp.com",
    databaseURL: "https://arons-site.firebaseio.com",
    projectId: "arons-site",
    storageBucket: "arons-site.appspot.com",
    messagingSenderId: "74377028451",
    appId: "1:74377028451:web:232541475e359530e46956"
};